// removed by extract-text-webpack-plugin
module.exports = {"box":"qempo_InTransit_box-3Trp_wU","disabled":"qempo_InTransit_disabled-35iiMIL","loading":"qempo_InTransit_loading-1ZggkJ-","tracking":"qempo_InTransit_tracking-2iTUFNG","trackingNumber":"qempo_InTransit_trackingNumber-3i8s2vC","report":"qempo_InTransit_report-1_Lr1KB","confirm":"qempo_InTransit_confirm-3YEc_Ro"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Purchase/in-transit/components/InTransit.scss
// module id = 1859
// module chunks = 0